export default __webpack_public_path__ + "static/media/copy.a3f45935.svg";